import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=3ea7572a&scoped=true&"
import script from "./Faqs.vue?vue&type=script&lang=js&"
export * from "./Faqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea7572a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea7572a')) {
      api.createRecord('3ea7572a', component.options)
    } else {
      api.reload('3ea7572a', component.options)
    }
    module.hot.accept("./Faqs.vue?vue&type=template&id=3ea7572a&scoped=true&", function () {
      api.rerender('3ea7572a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/Faqs.vue"
export default component.exports